<template>
  <div v-if="result.captcha">
    <q-img :src="result.captcha.imageUrl" class="q-my-md full-width"  />
    <form @submit.prevent="solve">
      <q-input v-model="solution" placeholder="Enter the chacters you see above" outlined />
      <div class="text-center q-my-md">
        <async-btn
          :task="task"
          type="submit"
          label="Continue"
          color="primary"
          class="full-width"
          rounded
        />
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { solveCaptcha, LoginResult } from '.';

interface Data {
  solution: string,
  task: Promise<LoginResult>|null,
}

export default defineComponent({
  emits: ['error', 'result'],
  components: { AsyncBtn },
  mixins: [HasTaskMixin],
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    result: {
      type: Object as () => LoginResult,
      required: true,
    },
  },
  data(): Data {
    return {
      solution: '',
      task: null,
    };
  },
  methods: {
    solve() {
      this.task = solveCaptcha(this.sessionId, this.solution);
      this.task.then((result) => {
        this.solution = '';
        this.$emit('result', result);
      });
      this.task.catch(() => {
        this.$emit('error');
      });
    },
  },
});
</script>
